export default __webpack_public_path__ + "static/media/timer.2ffdc13b.svg";